export const tag_list_art_periods_ko=["1940년대"	,
"1950년대"	,
"1960년대"	,
"1970년대"	,
"1980년대"	,
"1990년대"	,
"미술"	,
"아르누보"	,
"예술 & 공예"	,
"바로크"	,
"바우 하우스"	,

"현대의"	,
"고딕"	,
"그래피티"	,
"인상파"	,

"모더니즘"	,
"사이키델릭한"	,
"펑크"	,
"레트로"	,
"거리 미술"	,]
export const tag_list_colours_ko=[
    


"물"	,
"검정"	,
"무채색"	,
"푸른"	,
"파란색 & 흰색"	,
"밝은"	,
"갈색"	,
"화려한"	,
"산호색"	,
"크림색"	,
"청록색"	,
"어두운"	,
"진한 블루"	,
"짙은 녹색"	,


"금"	,
"녹색"	,
"회색"	,
"인디고"	,
"무지개색"	,
"빛"	,
"라일락"	,
"마젠타"	,
"멀티 컬러"	,
"남색"	,
"네온"	,

"주황색"	,
"파스텔"	,
"분홍색"	,
"보라색"	,
"빨간색"	,


"은"	,
"청록색"	,
"터키석"	,
"강렬한"	,
"제비꽃"	,
"하얀색"	,
"노란색"	,]
export const tag_list_pattern_types_ko=["3D"	,
"아프리카의"	,
"아즈텍"	,
"반다나"	,
"바틱염색"	,
"식물"	,
"꽃다발"	,
"만화"	,
"셰브런"	,
"중국풍의"	,

"원"	,
"장미"	,
"장식적인"	,
"잔꽃무늬"	,
"낙서"	,
"점"	,
"자수"	,
"이국적인"	,
"사람들"	,
"민속학의"	,
"풀라드"	,

"깅엄 체크"	,
"여자"	,
"하와이안"	,
"하트"	,
"헤링본"	,
"하운드투스"	,
"이카트"	,
"삽화"	,
"인디언"	,

"자카드"	,
"일본의"	,
"기모노"	,
"니트"	,
"레이스"	,
"대규모"	,
"만다라"	,
"대리석"	,
"멕시칸"	,
"모로코"	,

"모자이크"	,
"모티프"	,


"북유럽의"	,
"동양의"	,
"장식용"	,
"페이즐리"	,
"패치워크"	,

"스카프"	,
"모양"	,
"시보리"	,
"단순한"	,
"소규모"	,
"간격"	,

"점"	,
"사각형"	,
"별"	,

"타탄"	,
"타이다이"	,
"삼각형"	,

"엮다"	,
"지그재그"	,]
export const tag_list_pattern_techniques_ko=["추상적인 꽃"	,
"예술적"	,
"큰 꽃"	,
"흐릿한"	,
"용감한"	,
"붓터치"	,
"콜라주"	,

"귀여운"	,
"섬세한"	,
"디지털"	,
"왜곡된"	,

"시든"	,
"번창한"	,
"재미있는"	,
"미래"	,
"그래픽"	,
"그래픽 꽃"	,
"그래픽 패턴"	,
"그런지"	,
"손으로 그린"	,
"잉크"	,
"만화경"	,
"레이어"	,
"선"	,
"윤곽"	,
"최소의"	,
"거울"	,
"혼합 미디어"	,
"현대의"	,
"단색화"	,
"순진한"	,
"옴브레"	,
"옵티컬"	,

"그린"	,
"사진"	,
"픽셀"	,
"장난기"	,
"예쁜"	,
"로맨틱"	,
"낙서하다"	,
"실루엣"	,
"스케치"	,

"스텐실"	,
"소용돌이"	,
"대칭"	,
"색조의"	,
"벡터 패턴"	,
"빈티지"	,
"수채화"	,]
export const tag_list_food_drink_ko=["사과"	,
"바나나"	,
"사탕"	,
"체리"	,
"음료수"	,
"음식"	,
"과일"	,
"아이스크림"	,
"레몬"	,
"파인애플"	,
"딸기"	,
"과자"	,
"채소"	,]
export const tag_list_objects_ko=["건축"	,
"보트"	,
"자동차"	,
"쇠사슬"	,
"크리스마스"	,
"구름"	,
"다이아몬드"	,
"깃털"	,
"은하"	,
"휴가"	,
"보석"	,
"정글"	,
"풍경"	,
"편지"	,
"선박의"	,
"번호"	,
"대양"	,
"사람들"	,
"식물"	,
"두개골"	,
"우주"	,

"나무"	,
"벽지"	,
"파도"	,
"포장지"	,]
export const tag_list_seasons_ko=["가을"	,
"가을/겨울"	,


"가을"	,
"가을/겨울"	,
"할로윈"	,
"한 여름"	,

"리조트"	,
"봄"	,
"봄/여름"	,
"여름"	,
"여름 축제"	,
"발렌타인"	,
"겨울"	,]
export const tag_list_flowers_leaves_ko=["대나무"	,
"꽃"	,
"블로썸"	,
"선인장"	,
"수선화"	,
"데이지"	,
"양치식물"	,
"나뭇잎"	,
"숲"	,
"핫핑크색"	,
"히비스커스"	,
"붓꽃"	,
"라벤더"	,
"나뭇잎"	,
"백합"	,
"목련"	,
"목초지"	,

"난초"	,
"손바닥"	,
"팬지"	,
"모란"	,
"꽃잎"	,
"양귀비"	,
"장미"	,


"튤립"	,
"야생화"	,]
export const tag_list_animals_birds_ko=["딱정벌레"	,
"새"	,
"나비"	,
"고양이"	,
"개"	,
"돌고래"	,
"코끼리"	,
"생선"	,
"플라밍고"	,
"개구리"	,
"기린"	,
"말"	,
"곤충"	,
"표범무늬"	,
"나방"	,
"앵무새"	,
"토끼"	,
"뱀"	,
"불가사리"	,
"호랑이"	,
"고래"	,
"얼룩말"	,]